import { StaticApi } from '@/api';
import { LOCALE_CODE_DEFAULT } from '../constants';

let tempAllStations = null;

export async function getStationInfo(
  stationCode: string,
): Promise<StationInfo> {
  const allStations =
    tempAllStations || (await StaticApi.getStations(LOCALE_CODE_DEFAULT));

  //cache for future use
  tempAllStations = allStations;

  const stationInfo = allStations.find((s) => s.StationCode === stationCode);

  if (stationInfo) {
    return {
      lat: stationInfo.Lat,
      dest: stationInfo.Dest,
      long: stationInfo.Long,
      pinYin: stationInfo.PinYin,
      aaFlight: stationInfo.AAFlight,
      cityCode: stationInfo.CityCode,
      cityName: stationInfo.CityName,
      timeZone: stationInfo.TimeZone,
      airportName: stationInfo.AirportName,
      countryCode: stationInfo.CountryCode,
      countryName: stationInfo.CountryName,
      stationCode: stationInfo.StationCode,
      stationName: stationInfo.StationName,
      alternativeName: stationInfo.AlternativeName,
      stationType: stationInfo.StationType,
      tag: stationInfo.Tag,
    };
  }
}

export async function getFlightTerminalInfo(
  departureStation: string,
  arrivalStation: string,
  carrierCode: string,
  flightNumber: string,
  departureDate: string,
): Promise<FlightTerminalInfo> {
  const allTerminalInfo = await StaticApi.getTerminalInfo(departureDate);

  const terminalInfo = allTerminalInfo.find(
    (t) =>
      String(t.CarrierCode).toLowerCase() ===
        String(carrierCode).toLowerCase() &&
      String(t.FlightNumber).toLowerCase() ===
        String(flightNumber).toLowerCase() &&
      String(t.DepartureStation).toLowerCase() ===
        String(departureStation).toLowerCase() &&
      String(t.ArrivalStation).toLowerCase() ===
        String(arrivalStation).toLowerCase(),
  );

  if (terminalInfo) {
    return {
      arrivalStation: terminalInfo.ArrivalStation,
      arrivalTerminal: (terminalInfo.ArrivalTerminal || '').replaceAll(' ', ''),
      carrierCode: terminalInfo.CarrierCode,
      departureStation: terminalInfo.DepartureStation,
      departureTerminal: (terminalInfo.DepartureTerminal || '').replaceAll(
        ' ',
        '',
      ),
      flightNumber: terminalInfo.FlightNumber,
      departureDate,
    };
  }
}
